import routePaths from "../../Navigation/routePaths";
import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, SIGNUP_REQUEST, SIGNUP_SUCCESS, SIGNUP_FAILURE, TOGGLE_PASSWORD, FORGET_PASSWORD_REQUEST, FORGET_PASSWORD_SUCCESS, ONBOARDING_NAVIGATION_REQUEST, ONBOARDING_NAVIGATION_RESET, UPDATE_FORGET_PASSWORD_OTP, TOGGLE_CONFIRM_PASSWORD, RESET_PASSWORD_SUCCESS, ME_CALL_SUCCESS, PERMISSIONS_CALL_REQUEST, PERMISSIONS_CALL_REQUEST_SUCCESS } from "../../redux/action_constant";
import { AuthActions, AuthState, permissionsInterface, userInterface } from "./onBoardingTypes";

const initialState: AuthState = {
    pending: false,
    token: localStorage.getItem("token") || "",
    error: null,
    loading: false,
    showPassword: false,
    showConfirmPassword: false,
    forgetPasswordEmail: "",
    navigateTO: "",
    forgetPasswordOTP: "",
    user: {} as userInterface,
    permissions: [] as permissionsInterface[]
};

const OnBoardingReducer = (state = initialState, action: AuthActions) => {
    switch (action.type) {
        case SIGNUP_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case SIGNUP_FAILURE:
            return {
                ...state,
                pending: false,
                token: "",
                error: action.payload.error,
            };
        case SIGNUP_SUCCESS:
            return {
                ...state,
                pending: false,
                token: action.payload.token,
                error: null,
            };
        case LOGIN_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case LOGIN_SUCCESS:
            return {
                ...state,
                pending: false,
                token: action.payload.token,
                user: action.payload.user,
                error: null,
            };
        case ME_CALL_SUCCESS:
            return {
                ...state,
                pending: false,
                user: action.payload,
                error: null,
            };
        case LOGIN_FAILURE:
            return {
                ...state,
                pending: false,
                token: "",
                error: action.payload.error,
            };
        case PERMISSIONS_CALL_REQUEST_SUCCESS:
            return {
                ...state,
                permissions: action.payload,
            };
        case TOGGLE_PASSWORD:
            return { ...state, showPassword: !state.showPassword };
        case TOGGLE_CONFIRM_PASSWORD:
            return { ...state, showConfirmPassword: !state.showConfirmPassword };
        case FORGET_PASSWORD_REQUEST:
            return { ...state };
        case FORGET_PASSWORD_SUCCESS:
            return { ...state, forgetPasswordEmail: action.payload.email };
        case ONBOARDING_NAVIGATION_REQUEST:
            return { ...state, navigateTO: action.payload };
        case ONBOARDING_NAVIGATION_RESET:
            return { ...state, navigateTO: '' };
        case UPDATE_FORGET_PASSWORD_OTP:
            return { ...state, forgetPasswordOTP: action.payload };
        case RESET_PASSWORD_SUCCESS:
            return { ...initialState, navigateTO: routePaths.LOGIN.path };
        default:
            return {
                ...state,
            };
    }
};

export default OnBoardingReducer;   